import React from "react"
import { StyledTextArea } from "components/views/atoms/forms/StyledInputs"
import { completeFormElementFactory } from "components/views/atoms/forms/completeFormElementFactory"

const FormTextArea = React.forwardRef(({ placeholder, name, rows = 6, valid = true, ...props }, ref) => (
  <StyledTextArea valid={valid} placeholder={placeholder} name={name} ref={ref} rows={rows} {...props} />
))

FormTextArea.displayName = "FormTextArea"

const CompleteFormTextArea = completeFormElementFactory(FormTextArea)

export { CompleteFormTextArea, FormTextArea }
